export const LABEL_OUT_FOR_DELIVERY = "label_out_for_delivery";
export const LABEL_DELIVERED = "label_delivered";
export const LABEL_LOST = "label_lost";
export const LABEL_RETURN_TO_SENDER = "label_return_to_sender";
